import request from '@/utils/request';
import {loginCompany, loginOrg} from "@/utils/LoginContext";

export async function save(payload) {
  return request(`/iwms-wms/wms/physicscheckntcbill?dcUuid=${loginOrg().uuid}&companyUuid=${loginCompany().uuid}`, {
    method: 'POST',
    body: payload,
  });
}

export async function saveAndApprove(payload) {
  return request(`/iwms-wms/wms/physicscheckntcbill/save/approve`, {
    method: 'POST',
    body: payload,
  });
}

export async function remove(payload) {
  return request(`/iwms-wms/wms/physicscheckntcbill/remove?uuid=${payload.uuid}&version=${payload.version}`, {
    method: 'DELETE',
  });
}

export async function modify(payload) {
  return request(`/iwms-wms/wms/physicscheckntcbill/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function query(payload) {
  return request(`/iwms-wms/wms/physicscheckntcbill/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function approve(payload) {
  return request(`/iwms-wms/wms/physicscheckntcbill/approve?uuid=${payload.uuid}&version=${payload.version}`, {
    method: 'POST'
  });
}

export async function check(payload) {
  return request(`/iwms-wms/wms/physicscheckbill/gen?ntcBillNumber=${payload.ntcBillNumber}&dcUuid=${payload.dcUuid}`, {
    method: 'POST'
  });
}

export async function get(uuid) {
  return request(`/iwms-wms/wms/physicscheckntcbill?uuid=${uuid}`);
}

export async function getByBillNumberAndDcUuid(payload) {
  return request(`/iwms-wms/wms/physicscheckntcbill/${payload.billNumber}?dcUuid=${payload.dcUuid}`);
}
